export const HELP_CENTER_URL = 'https://support.postermywall.com/hc/en-us/articles/360058560052?utm_source=editor&utm_medium=nav';

export enum HelpMenuOption {
  HELP_CENTER = 'help-center',
  KEYBOARD_SHORTCUTS = 'keyboard-shortcuts',
}
